import { UserDetailsBanner } from "~/modals/User/UserDetailsModal/components/UserDetailsBanner";
import type { User } from "~/shared.types";

export const StaffBookingHeader = ({
  user,
  email,
}: {
  user?: User;
  email: string;
}) => {
  if (user) return <UserDetailsBanner user={user} actions={[]} />;

  if (!email) return <div aria-hidden="true" className="h-2" />;

  return (
    <div className="bg-indigo min-h-16 px-8 py-5 text-base font-medium text-white">
      <span className="break-all">{email}</span>
    </div>
  );
};
